const IITDelhiFeeData = {
    coursefee: "9,05,000",
    hostelfee: "3,00,000",
};
export default IITDelhiFeeData;
